import { Box } from '@mui/material';
import CurriculumTableItem from '@/components/curriculum/curriculum-table-item';
import type { Chapter, Course } from '@/types';

export default function CurriculumTable({
  course,
  hasMembership,
}: {
  course: Course;
  hasMembership: boolean;
}) {
  const { curriculum } = course;
  const structured: {
    title: string;
    children: Chapter[];
    sectionChapter?: Chapter;
  }[] = [];

  curriculum.forEach((chapter: Chapter, index) => {
    const { item, style } = chapter;
    // If first item is not a headline, set custom headline
    if (index === 0 && style !== 'section') {
      structured.push({
        title: 'Inhalte',
        children: [],
        sectionChapter: undefined,
      });
    } else if (style === 'section') {
      structured.push({
        title: item.title,
        children: [],
        sectionChapter: chapter,
      });
    } else {
      structured[structured.length - 1].children.push(chapter);
    }
  });

  return (
    <Box>
      {structured.map(({ title, children, sectionChapter }, index) => (
        <CurriculumTableItem
          key={title}
          title={title}
          isOpen={index === 0}
          hasMembership={hasMembership}
          sectionChapter={sectionChapter}>
          {children}
        </CurriculumTableItem>
      ))}
    </Box>
  );
}
